
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4873_12004)"}},[_c('g',{attrs:{"clip-path":"url(#clip1_4873_12004)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.568 7L12 11.809 19.432 7H4.568zM4 9.015V17h16V9.015l-7.457 4.825-.543.351-.543-.351L4 9.015zM2 6a1 1 0 011-1h18a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V6z","fill":"#161616","fill-opacity":".88"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4873_12004"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_4873_12004"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    